import { restApiDP } from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApiDP.get("/api/bf-feature-analysis", { params })
};

const bfFeatureAnalysisService = {
  getAll
};

export default bfFeatureAnalysisService;